import React from 'react';
import * as styles from './NotFound.module.css';

function NotFound() {

  return <div className={styles.wrap}>Oops. There is no such thing here.</div>;
}

export default NotFound;
